import { render, staticRenderFns } from "./ZoneEdit.vue?vue&type=template&id=67a8d85e&"
import script from "./ZoneEdit.vue?vue&type=script&lang=js&"
export * from "./ZoneEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports